import { render, staticRenderFns } from "./MakeXP.vue?vue&type=template&id=1f56abe8"
import script from "./MakeXP.vue?vue&type=script&lang=js"
export * from "./MakeXP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports